// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__33-VL","rootSmall":"AddTileButton_rootSmall__N2EoP"};